<template lang="html">
    <!--footer-->
    <div  class="footerbig">
        <!-- <div class="footer"></div> -->
        <div class="footerbox mt40">
            <p class="tc f14 " >
                 主办单位：人力资源和社会保障部人事司、人力资源和社会保障部教育培训中心&nbsp;&nbsp;&nbsp;&nbsp;技术支持：中国创联教育集团
            </p>
            <p class="tc f14 ">
                <img src="/static/images/bq-icon_06.png" class="mr5">京公网安备 11010102002485号&nbsp;&nbsp; 京ICP：备11042657号 &nbsp;&nbsp; 人力资源和社会保障部教育培训中心网站
            </p>
            <p class="tc f14 " >
                Copyright2017. All right reserved edu.mohrss.gov.cn
            </p>
        </div>
    </div>
</template>
<style>
    .footerbox{background: #0b60a2;padding:  15px 0;}
    .footerbox p{color: #fff;letter-spacing: 1px;}
</style>
<script>
export default {
    name:'ft',
    data(){
        return{
          
        }
    },
    

}
</script>






// WEBPACK FOOTER //
// Footer.vue?3b26a972